import Vuex from "vuex";
import storeConfig from "./store-config";
import storeConfigTest from "./store-config-test";

export default new Vuex.Store(
  process.env.NODE_ENV !== "test" ? storeConfig : storeConfigTest
);
